import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileuploadParam',
  pure: true
})
export class FileuploadParamPipe implements PipeTransform {

  transform(dynField: any, args?: any): any {
    let fileUploadParams = {
      'AllowedFileTypes': dynField['DynFieldAllowedFileType'],
      'FileLabel': dynField['DynFieldName'],
      'ShowLabel': false,
      'FileId': dynField["EncodedFieldControlId"],
      'ImgPath': dynField["IsImageType"] == true ? dynField['FilePath'] : "",
      'FilePath' : dynField['FilePath'],
      'ShowImage': dynField["IsImageType"] == true,
      'AllowFileSize': dynField['DynFieldMaxFileUploadSize'],
      'ImgType': ''
    };
    return fileUploadParams;
  }

}
